import React from "react";
import PropTypes from "prop-types";
import Lock from "rialto-icons/Lock";
import AllAgents from "rialto-icons/ShareStatusAll";
import MeClient from "rialto-icons/ShareStatusBrokerOwnerTeam";
import MeTeam from "rialto-icons/ShareStatusBrokerTeamOwnerTeam";
import Custom from "rialto-icons/ShareStatusCustom";

import shareStatusIcon from "utils/shareStatusIcon";
import Translate from "utils/translate";

import Dropdown, { DropdownButton } from "../Dropdown";

import styles from "./ShareStatusSelector.css";

const { t } = new Translate("ShareStatusSelector");

const icons = (status) => {
  const statuses = {
    all: () => AllAgents,
    owner_team: () => Lock,
    broker_owner_team: () => MeClient,
    broker_team_owner_team: () => MeTeam,
    custom: () => Custom,
    default: () => null,
  };

  return (statuses[status] || statuses.default)();
};

const ShareStatusSelector = (props) => {
  const {
    allDisabled,
    currentStatus,
    customDisabled,
    isBroker,
    isCreator,
    isLarge,
    onSelect,
    sharedBrokerCount,
  } = props;

  let statuses = isBroker ? ["broker_team_owner_team", "broker_owner_team"] : ["owner_team"];
  if (!customDisabled) statuses = [...statuses, "custom"];
  if (!allDisabled) statuses = [...statuses, "all"];

  const label = isLarge
    ? t(`status.${currentStatus}`)
    : (currentStatus !== "owner_team" ? true : undefined) && sharedBrokerCount.toString();

  const Icon = shareStatusIcon(currentStatus);

  return isCreator ? (
    <Dropdown
      align="left"
      className={styles.dropdown}
      header={t("header")}
      inputComponent={DropdownButton}
      inputComponentProps={{ icon: icons(currentStatus), isLarge, label }}
      isFullWidth={false}
      onChange={onSelect}
      selectedValues={[currentStatus]}
      valueExtractor={(status) => status && { icon: icons(status), label: t(`status.${status}`) }}
      values={statuses}
      isUnselectable
    />
  ) : (
    <div className={styles.info}>
      <Icon size="small" />
      <span>{sharedBrokerCount}</span>
    </div>
  );
};

ShareStatusSelector.propTypes = {
  sharedBrokerCount: PropTypes.number,
  currentStatus: PropTypes.string.isRequired,
  onSelect: PropTypes.func,
  customDisabled: PropTypes.bool,
  allDisabled: PropTypes.bool,
  isBroker: PropTypes.bool,
  isCreator: PropTypes.bool,
  isLarge: PropTypes.bool,
};

ShareStatusSelector.defaultProps = {
  sharedBrokerCount: 0,
  currentStatus: "broker_team_owner_team",
};

export default ShareStatusSelector;
